import { S122gS122m01Component } from './s122g-s122m01.component';

export { S122gModule } from './s122g.module';

export const S122gSubComponentsMap = {
	
};

export const S122gComponentsMap = {
	"s122g-s122m01": S122gS122m01Component
};

export const S122gComponents = [
	S122gS122m01Component
];

